import { language } from "@chef/constants";

export const intl = (
  {
    no: {
      GIFT_CARD: "Gavekort",
      SOMETHING_WENT_WRONG: "Noe gikk galt",
      AN_ERROR_HAS_OCCURED:
        "Noen ganger svikter teknikken. Kan du prøve igjen? Kontakt kundeservice dersom problemet vedvarer.",
      TRY_AGAIN: "Prøv igjen",
      CONCTACT_SUPPORT: "Kontakt kundeservice",
    },
    se: {
      GIFT_CARD: "Presentkort",
      SOMETHING_WENT_WRONG: "Något gick fel",
      AN_ERROR_HAS_OCCURED:
        "Ibland är det tekniken som krånglar, får vi be dig att försöka igen? Om problemet kvarstår – kontakta vår kundtjänst.",
      TRY_AGAIN: "Forsök igen",
      CONCTACT_SUPPORT: "Kontakta kundtjänst",
    },
    dk: {
      GIFT_CARD: "Gavekort",
      SOMETHING_WENT_WRONG: "Något gik galt",
      AN_ERROR_HAS_OCCURED:
        "Nogle gange svigter teknologien. Må vi venligst bede dig om at prøve igen? Hvis problemet fortsætter, bedes du kontakte vores kundeservice.",
      TRY_AGAIN: "Prøv igen",
      CONCTACT_SUPPORT: "Kontakt kundeservice",
    },
  } as const
)[language];
